export const formatDueInspectionTypes = (record, translate) => {
    if (!record) {
        return null;
    }

    const types = [
        record.vdeInspectionDue ? translate("equip.skuInspectionType_vde") : null,
        record.uvvInspectionDue ? translate("equip.skuInspectionType_uvv") : null,
    ].filter(Boolean);

    return types.length > 0 ? types.join(" / ") : null;
};
